/**
 * Enum for entity types used in integration links and other entity-related APIs.
 * Matches the backend EntityType enum.
 */
export enum EntityType {
  User = 'USER',
  Project = 'PROJECT',
  Client = 'CLIENT',
  Invoice = 'INVOICE',
  Assignment = 'ASSIGNMENT',
  Worklog = 'WORKLOG',
  Issue = 'ISSUE',
}
